import axios from 'axios';

let util = {};

util.title = function (title) {
    title = title ? title + '- cntomy' : 'cntomy';
    window.document.title = title;
};

//const apiurl = "http://test.cntomy.org/api/v1/";
const apiurl = "http://api.cntomy.org/api/v1/";

util.ajax = axios.create({
    baseURL: apiurl,
    timeout: 30000
});


export default util;